const ICON_SIZE_PX = 20;

// A sheet with a prize ribbon; antd has no certificate icon (SafetyCertificate is a shield).
// One fixed size for the dashboard button and the dialog header; colour follows the text.
const CertificateIcon = () => (
  <svg
    width={ICON_SIZE_PX}
    height={ICON_SIZE_PX}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M12.5 18H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5" />
    <path d="M7 7.5h8M7 11h4.5" />
    <circle cx="17" cy="14.5" r="3" />
    <path d="M15.2 17.1V21.5l1.8-1.3 1.8 1.3v-4.4" />
  </svg>
);

export default CertificateIcon;
